import correct from '@/assets/img/documents/house-hold/decyzja.jpg';
import wrong from '@/assets/img/documents/house-hold/decyzja-wrong.jpg';

import Card from '@/components/Card';
import ChatMessage from '@/components/ChatMessage';
import { Uploader } from '@/components/ui/Uploader/Uploader';
import { ATTACHMENT_TYPES } from '@/consts';

import { useLingui } from '@lingui/react';

export const INSURERS_DECISION_NAME = 'insurers_decision';

const InsurersDecision = ({ required = false }: { required?: boolean }) => {
  const { i18n } = useLingui();

  const instructionProps = {
    title: i18n.t('Jak poprawnie dodać decyzję ubezpieczyciela?'),
    steps: [
      i18n.t('Upewnij się, że wszystkie dane nieruchomości są widoczne.'),
      i18n.t('Sprawdź, czy załączasz wszystkie strony decyzji.'),
      i18n.t('Jeśli przesyłasz zdjęcia – sprawdź, czy dokument jest czytelny.'),
      i18n.t('Jeśli plik jest zabezpieczony – dołącz hasło.'),
    ],
    correctImg: correct,
    wrongImg: wrong,
  };

  return (
    <div>
      <Card>
        <Uploader
          title={i18n.t('Decyzja ubezpieczyciela')}
          instructionProps={instructionProps}
          inputFieldName={INSURERS_DECISION_NAME}
          required={required}
          attachmentTypeId={ATTACHMENT_TYPES.DECYZJA}
          data-testid={`${INSURERS_DECISION_NAME}-uploader`}
        />
      </Card>
      {!required && (
        <ChatMessage
          variant="secondary"
          className="mt-3 lg:mt-5"
          description={
            'Jeśli nie posiadasz jeszcze decyzji ubezpieczyciela, to nic nie szkodzi. Możesz przesłać nam ją w późniejszym czasie.'
          }
        />
      )}
    </div>
  );
};

export default InsurersDecision;
